<template>
  <v-list-item
    :class="['chat-list-item', { active: isActive }]"
    @click="emit('select', chat.id)"
  >
    <v-list-item-title class="text-truncate">
      {{ previewText }}
    </v-list-item-title>
  </v-list-item>
</template>

<script setup lang="ts">
  import { defineProps, defineEmits } from 'vue';
  import type { Chat } from '@/types/chat';

  const props = defineProps<{
    chat: Chat;
    isActive?: boolean;
  }>();
  const emit = defineEmits<{
    (e: 'select', chatId: string): void;
  }>();

  // Fallback to 'Untitled Chat' if no messages or message text
  const previewText = props.chat.title;
</script>

<style scoped lang="sass">
  .text-truncate
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

  .chat-list-item
    min-height: 48px
    padding: 8px 16px
    border: 1px solid transparent
    transition: background-color 0.2s ease


  .chat-list-item.active
    background-color: rgba(227, 242, 253)
</style>
